export default {
  operationWasSuccessfull: 'عملیات با موفقیت انجام شد',
  pleaseConvertToValidPoint: 'نقاط را تبدیل به دیتای معتبر نقشه کنید',
  AreYouSureAboutTheOperation‌: 'آیا از انجام عملیات اطمینان دارید؟',
  notificationType: 'نوع اطلاعیه',
  broadcast: 'Broadcast',
  multicast: 'Multicast',
  unicast: 'Unicast',
  expireTime: 'زمان انقضا',
  silent: 'بدون صدا',
  creationTime: 'تاریخ ایجاد',
  link: 'پیوند',
  send: 'ارسال',
  sendDemo: 'ارسال آزمایشی',
  sender: 'ارسال کننده',
  contents: 'توضیحات',
  event: 'رویداد',
  recipientMobile: 'موبایل گیرنده',
  recipientEmail: 'ایمیل گیرنده',
  recipientKey: 'شناسه گیرنده',
  recipientAdmin: 'گیرنده ادمین',
  recipientAnonymous: 'گیرنده ناشناش',
  gateway: 'درگاه',
  recipientDemo: 'گیرنده دمو',
  sentReport: 'مشاهده گزارش ارسال شده ها',
  smsType: 'نوع پیامک',
  unit: 'Unit',
  bulk: 'Bulk',
  emailType: 'نوع پست الکترونیکی',
  internalType: 'نوع پیام داخلی',
  eventType: 'نوع رویداد',
  userOtpSend: 'ارسال کد فعال سازی',
  userRegister: 'ثبت‌نام',
  companyRegister: 'ثبت باربری',
  shipmentCreateNotice: 'اطلاع رسانی ثبت سفارش',
  ShipmentCreateReminderInOfficeHour: 'پیگیری ثبت سفارش در ساعت اداری',
  ShipmentCreateReminderOutOfficeHour: 'پیگیری ثبت سفارش در ساعت غیر اداری',
  ShipmentCancelNotice: 'اطلاع رسانی لغو سفارش',
  ShipmentOfferCompanyAcceptNotice: 'اطلاع رسانی قبول سفارش پیشنهادی',
  ShipmentOfferCompanyPricingNotice: 'اطلاع رسانی تعیین قیمت سفارش پیشنهادی',
  ShipmentOfferUserAcceptNotice: 'اطلاع رسانی قبول سفارش قیمت داده شده',
  ShipmentAllOfferCanceledNotice: 'اطلاع رسانی لغو سفارش پیشنهادی',
  ShipmentNoneOfferAcceptedNotice: 'اطلاع رسانی عدم قبول سفارش پیشنهادی',
  ShipmentAssignNotice: 'اطلاع رسانی اختصاص راننده',
  ShipmentReassignNotice: 'اطلاع رسانی اختصاص مجدد راننده',
  DriverInitiateNotice: 'اطلاع رسانی حرکت راننده',
  DriverDischargeNotice: 'اطلاع رسانی تخلیه بار',
  PropertyItemFeatureCreateNotice: 'ثبت اقلام',
  PropertyItemFeatureUpdateNotice: 'ویرایش اقلام',
  PropertyEmployeeCreateNotice: 'ثبت نیروی فنی',
  PropertyEmployeeUpdateNotice: 'ویرایش نیروی فنی',
  CarModelFeatureCreateNotice: 'ثبت خودرو',
  CarModelFeatureUpdateNotice: 'ویرایش خودرو',
  FeedbackCreateNotice: 'ثبت بازخورد',
  deleted: 'حذف شده',
  messageTitle: 'عنوان پیام',
  messageDescription: 'توضیحات پیام',
  notification: 'اعلان هشدار',
  gatewayResponse: 'پاسخ درگاه',
  unsuccessfulDeliver: 'تحویل مرسوله ناموفق بود'
}
